// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2Jc3B","notes":"Notes_notes__3kqQD"};